import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    title: {
      textAlign: "center",
    },
    subtitle: {
      textAlign: "center",
    },
    recurringContributionContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      backgroundColor: theme.relink.recurring.background,
      borderRadius: 16,
      padding: spacing.m,
    },
    recurringContributionIcon: {
      width: 34,
      height: 34,
      borderRadius: 17,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: spacing.s,
      backgroundColor: theme.relink.recurring.icon.background,
      flexShrink: 0,
    },
    recurringContributionContent: {
      flex: 1,
    },
    recurringContributionTitle: {
      fontWeight: 500,
    },
    badge: {
      display: "inline-block",
      marginTop: spacing.xxs,
      borderWidth: 1,
      borderStyle: "solid",
      borderRadius: 4,
      borderColor: theme.text.secondary,
      paddingLeft: spacing.xxxs,
      paddingRight: spacing.xxxs,
      paddingTop: 1,
      paddingBottom: 1,
    },
    badgeText: {
      color: theme.text.secondary,
      fontWeight: 500,
      lineHeight: "14px",
    },
    protection: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
    protectionText: {
      color: theme.text.tertiary,
      marginLeft: spacing.xxs,
    },
    supportCtaText: {
      textAlign: "center",
      color: theme.text.secondary,
      textDecoration: "underline",
      marginTop: spacing.xs,
      marginBottom: spacing.xs,
      cursor: "pointer",
    },
    exclamation: {
      display: "block",
      margin: "0 auto",
    },
    amount: {
      flexShrink: 0,
      fontWeight: 500,
    },
  };

  return styles;
};
